import { ReceiptClaimScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ReceiptClaimScreen />;
}
